import * as React from 'react';

const Eyeon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M3.41341 10C5.51218 12.9287 7.82231 14.25 10 14.25C12.1777 14.25 14.4878 12.9287 16.5866 10C14.4878 7.0713 12.1777 5.75 10 5.75C7.82231 5.75 5.51218 7.0713 3.41341 10ZM10 4.25C12.9709 4.25 15.7967 6.13612 18.1216 9.5804C18.2928 9.83395 18.2928 10.166 18.1216 10.4196C15.7967 13.8639 12.9709 15.75 10 15.75C7.0291 15.75 4.20325 13.8639 1.87836 10.4196C1.70721 10.166 1.70721 9.83395 1.87836 9.5804C4.20325 6.13612 7.0291 4.25 10 4.25ZM10 8.25C9.53587 8.25 9.09075 8.43437 8.76256 8.76256C8.43437 9.09075 8.25 9.53587 8.25 10C8.25 10.4641 8.43437 10.9092 8.76256 11.2374C9.09075 11.5656 9.53587 11.75 10 11.75C10.4641 11.75 10.9092 11.5656 11.2374 11.2374C11.5656 10.9092 11.75 10.4641 11.75 10C11.75 9.53587 11.5656 9.09075 11.2374 8.76256C10.9092 8.43437 10.4641 8.25 10 8.25ZM7.7019 7.7019C8.3114 7.09241 9.13805 6.75 10 6.75C10.862 6.75 11.6886 7.09241 12.2981 7.7019C12.9076 8.3114 13.25 9.13805 13.25 10C13.25 10.862 12.9076 11.6886 12.2981 12.2981C11.6886 12.9076 10.862 13.25 10 13.25C9.13805 13.25 8.3114 12.9076 7.7019 12.2981C7.09241 11.6886 6.75 10.862 6.75 10C6.75 9.13805 7.09241 8.3114 7.7019 7.7019Z"
      fill="#71717A"
    />
  </svg>
);
export default Eyeon;
